
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cart_g7RgjNHbCkIkDoW3iJUmtGCFj76pFCKRlKCHaNlVawMeta } from "/opt/build/repo/pages/cart.vue?macro=true";
import { default as testE9QxVsjMb2FKIbRzzNvAT_coju3CQ80AfargDQUoMcwMeta } from "/opt/build/repo/pages/test.vue?macro=true";
import { default as aboutcmOlMtgh0xy7aWxAyOhlQufva4uyAY4tLm1ILX3BBaUMeta } from "/opt/build/repo/pages/about.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as legacy2Z_uvoPSIPujubs7HV3nGa0GfWHSK4G3qmkV2p1Dr58Meta } from "/opt/build/repo/pages/legacy.vue?macro=true";
import { default as search40azIuQO_45V5O416T2UUEtXxMQd2LugEuEKr9RgZDQWkMeta } from "/opt/build/repo/pages/search.vue?macro=true";
import { default as new_45nowk4cMlVYAYjQNWvQf5Vf_gQz_J9n6SLYwje_UzMfZsWkMeta } from "/opt/build/repo/pages/new-now.vue?macro=true";
import { default as locationBqusjqcY_h7yzSDLFhlOH_mWMQlqtNDdStEjaPk9eh8Meta } from "/opt/build/repo/pages/location.vue?macro=true";
import { default as lookbookqVbzVlVTK11hlkXfYN2S0_45xa9ThJIlGNcywasubyXx4Meta } from "/opt/build/repo/pages/lookbook.vue?macro=true";
import { default as gift_45cardeTtSlu8lvsBiVnUI9WwidmFigl2x6QzfNSpw8iC1pukMeta } from "/opt/build/repo/pages/gift-card.vue?macro=true";
import { default as event_45listEcTDXePgmAw0xpreE7af77E4HY3fCKKRX8zgQ0Kj7aIMeta } from "/opt/build/repo/pages/event-list.vue?macro=true";
import { default as must_45havesJnwD4iIkQGa76lLgSZo38rU_dAtTNMEHbnVbDjJFueMMeta } from "/opt/build/repo/pages/must-haves.vue?macro=true";
import { default as _91slug_93__45dzJBGpTw0AUSJ7kjWIfsjpDeiJPPe_Cc5rSf34msQMeta } from "/opt/build/repo/pages/blog/[slug].vue?macro=true";
import { default as indexp8kFPrPgRI8C5dDFGnCCYpgg_0ieuaHjkDY1OCw_45yJEMeta } from "/opt/build/repo/pages/press/index.vue?macro=true";
import { default as index48RFVteGt04ugDAeid_45Ysstg_45dpZckxviC3IIbj7tzYMeta } from "/opt/build/repo/pages/shops/index.vue?macro=true";
import { default as indexh5OpEkCiBfBuKh8lLF38ROyg8331j3CpTQvrR_8AsRIMeta } from "/opt/build/repo/pages/dining/index.vue?macro=true";
import { default as _91slug_93cpT8d1Crtl08Sdu8id7dIBgu6uWLsxrMjrDeQMoVRfgMeta } from "/opt/build/repo/pages/event/[slug].vue?macro=true";
import { default as new_45in_45storesQjQsSDtkoBvzO8rbVFTgBqEPQJE_VOqIFWyzP44exgMeta } from "/opt/build/repo/pages/new-in-store.vue?macro=true";
import { default as _91slug_93xSAno86fLKSVq1F9AcLrP4KnMKHP9TCMJABk0onGybQMeta } from "/opt/build/repo/pages/pages/[slug].vue?macro=true";
import { default as partnershipsOh9rdE8C_45CbKoLGZ_nt_45LbUT4lydgLSgYYl__45q4p6qkMeta } from "/opt/build/repo/pages/partnerships.vue?macro=true";
import { default as _91slug_93hYc8_45JW1w4LvlblllhsaM_ufnvMG6MEDcGqPhyLjTisMeta } from "/opt/build/repo/pages/press/[slug].vue?macro=true";
import { default as index1S_45nq4a5NI2Cf6_45VOvWwyA4dyaWzs_taM5Wse0vbuEQMeta } from "/opt/build/repo/pages/careers/index.vue?macro=true";
import { default as guest_45servicesAVOeawDXrBTBSLXr5CEWuWhVPxSwD_45r0vFZ4IXUyOKYMeta } from "/opt/build/repo/pages/guest-services.vue?macro=true";
import { default as personal_45shopper0XfIErwZ93GbDeS_TMGRs7aFEXGgAjs_vT6boCe_45BrIMeta } from "/opt/build/repo/pages/personal-shopper.vue?macro=true";
import { default as travel_45resourcesKzn2r_457ioTc14dE0j3PGSyHBDBYqlJzMkoQRyXS0hdYMeta } from "/opt/build/repo/pages/travel-resources.vue?macro=true";
import { default as newsletter_45signupNW4Aaa93h_au260XhHJ4TafxK7CJWsCA_gWe_FRCboUMeta } from "/opt/build/repo/pages/newsletter-signup.vue?macro=true";
import { default as _91category_93gr3FsbqxgHUZHbXAaQ3ycriNo_3A6iaJKdY7yoma9TAMeta } from "/opt/build/repo/pages/category/[category].vue?macro=true";
import { default as indexLwqy8KNbrLxceKp42CDjOVPZWflLlz5QvI8yU3T3IbQMeta } from "/opt/build/repo/pages/store-directory/index.vue?macro=true";
import { default as _91slug_93kjDQqnxCyGK5APbgywGWwJIo0R1BDod9voj45LtcS3sMeta } from "/opt/build/repo/pages/store-directory/[slug].vue?macro=true";
import { default as indexJ0BbHfoPwmzWfkymSQ_vIbwz2O32Up_45YuadbrMcRFNwMeta } from "/opt/build/repo/pages/press/in-the-news/index.vue?macro=true";
import { default as index0HSMtb170659M6pHo8w_453_45xPceNzjARZo4Lg42Ifat0Meta } from "/opt/build/repo/pages/press/press-releases/index.vue?macro=true";
import { default as newsletter_45signup_45confirmationfYACuPxT2gK7xBo_45S_ZTEhKp9tCtFDTEVOBq39JLaiUMeta } from "/opt/build/repo/pages/newsletter-signup-confirmation.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/build/repo/pages/cart.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/build/repo/pages/test.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/build/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "legacy",
    path: "/legacy",
    component: () => import("/opt/build/repo/pages/legacy.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/build/repo/pages/search.vue")
  },
  {
    name: "new-now",
    path: "/new-now",
    component: () => import("/opt/build/repo/pages/new-now.vue")
  },
  {
    name: "location",
    path: "/location",
    component: () => import("/opt/build/repo/pages/location.vue")
  },
  {
    name: "lookbook",
    path: "/lookbook",
    component: () => import("/opt/build/repo/pages/lookbook.vue")
  },
  {
    name: "gift-card",
    path: "/gift-card",
    component: () => import("/opt/build/repo/pages/gift-card.vue")
  },
  {
    name: "event-list",
    path: "/event-list",
    component: () => import("/opt/build/repo/pages/event-list.vue")
  },
  {
    name: "must-haves",
    path: "/must-haves",
    component: () => import("/opt/build/repo/pages/must-haves.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/opt/build/repo/pages/blog/[slug].vue")
  },
  {
    name: "press",
    path: "/press",
    component: () => import("/opt/build/repo/pages/press/index.vue")
  },
  {
    name: "shops",
    path: "/shops",
    component: () => import("/opt/build/repo/pages/shops/index.vue")
  },
  {
    name: "dining",
    path: "/dining",
    component: () => import("/opt/build/repo/pages/dining/index.vue")
  },
  {
    name: "event-slug",
    path: "/event/:slug()",
    component: () => import("/opt/build/repo/pages/event/[slug].vue")
  },
  {
    name: "new-in-store",
    path: "/new-in-store",
    component: () => import("/opt/build/repo/pages/new-in-store.vue")
  },
  {
    name: "pages-slug",
    path: "/pages/:slug()",
    component: () => import("/opt/build/repo/pages/pages/[slug].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/opt/build/repo/pages/partnerships.vue")
  },
  {
    name: "press-slug",
    path: "/press/:slug()",
    component: () => import("/opt/build/repo/pages/press/[slug].vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/opt/build/repo/pages/careers/index.vue")
  },
  {
    name: "guest-services",
    path: "/guest-services",
    component: () => import("/opt/build/repo/pages/guest-services.vue")
  },
  {
    name: "personal-shopper",
    path: "/personal-shopper",
    component: () => import("/opt/build/repo/pages/personal-shopper.vue")
  },
  {
    name: "travel-resources",
    path: "/travel-resources",
    component: () => import("/opt/build/repo/pages/travel-resources.vue")
  },
  {
    name: "newsletter-signup",
    path: "/newsletter-signup",
    component: () => import("/opt/build/repo/pages/newsletter-signup.vue")
  },
  {
    name: "category-category",
    path: "/category/:category()",
    component: () => import("/opt/build/repo/pages/category/[category].vue")
  },
  {
    name: "store-directory",
    path: "/store-directory",
    component: () => import("/opt/build/repo/pages/store-directory/index.vue")
  },
  {
    name: "store-directory-slug",
    path: "/store-directory/:slug()",
    component: () => import("/opt/build/repo/pages/store-directory/[slug].vue")
  },
  {
    name: "press-in-the-news",
    path: "/press/in-the-news",
    component: () => import("/opt/build/repo/pages/press/in-the-news/index.vue")
  },
  {
    name: "press-press-releases",
    path: "/press/press-releases",
    component: () => import("/opt/build/repo/pages/press/press-releases/index.vue")
  },
  {
    name: "newsletter-signup-confirmation",
    path: "/newsletter-signup-confirmation",
    component: () => import("/opt/build/repo/pages/newsletter-signup-confirmation.vue")
  }
]